module.exports = __webpack_public_path__ + "static/media/MenuNachos.e7bf08c6.jpg";